import React from "react";
import AvailabilityManager from "scenes/employee/AvailabilityManager";
import "styles/employee.css";

const AvailabilityTab = () => <AvailabilityManager isAdmin />;

export default AvailabilityTab;
